import { getIcon } from "@/constants";
import { ReactSVG } from "react-svg";

interface Props {
    title: string;
    subtitle: string;
}

export default function StepHeader({ title, subtitle }: Props) {
    return (
        <div className="flex flex-col items-center gap-y-2">
            <h2 className="text-3xl font-bold tracking-tight text-gray-900 capitalize">
                {title}
            </h2>
            <ReactSVG
                src={getIcon("title_arrow.svg")}
                className="relative w-20 text-orange-700 ltr:rotate-180"
            />
            <p className="text-base leading-7 text-gray-600 first-letter:uppercase">
                {subtitle}
            </p>
        </div>
    );
}
